import Vue from 'vue';

import { SESSION_LENGTH_MS, SLOT_USER_LIMIT, SLOT_INTERVAL_MS } from "@/constants_calendar";

import { getMatchabilityScore } from "../utilities/comparisonUtilities";

// function calculateScore() {
//   return Math.random();
// }

const getDefaultState = function() {
  return {
    /**
     * @key dateTimeMS 
     * @value {Array} array of matchpool users. Each array is maximally SLOT_USER_LIMIT long 
     * Array elements are the following objects 
     *  {
     *    matchableID: {String} the ID of the matchable user
     *    score: {Number} the matchscore of the matchable user
     *    session: {Object} the public session data (worktype, rematchAllowed) of the matchable user
     *  }
     */
    matchPoolUsers: {},
    dataStartMS: Math.floor(Date.now()/SLOT_INTERVAL_MS)*SLOT_INTERVAL_MS,
    dataEndMS: Math.floor(Date.now()/SLOT_INTERVAL_MS)*SLOT_INTERVAL_MS,
  };
};


const state = getDefaultState();

const getters = {
  getBestMatchID: (state) => (dateTimeMS) => 
    state.matchPoolUsers[dateTimeMS] && state.matchPoolUsers[dateTimeMS].length 
      ? state.matchPoolUsers[dateTimeMS][0].matchableID 
      : null,
  getBestMatchSession: (state) => (dateTimeMS) => 
    state.matchPoolUsers[dateTimeMS] && state.matchPoolUsers[dateTimeMS].length 
    ? state.matchPoolUsers[dateTimeMS][0].session 
    : null,
  getUserSessionsForSlot: (state) => (dateTimeMS) =>
    state.matchPoolUsers[dateTimeMS] && state.matchPoolUsers[dateTimeMS].length 
    ? state.matchPoolUsers[dateTimeMS] 
    : null,
};

const mutations = {
  /** 
   * Sets selection partner, i.e. updates the score of the chosen partner
   */
  SET_SELECTION_PARTNER(state, swapData) {
    const { oldBestScore, chosenIndex, dateTimeMS } = swapData;
    /* console.log("@SET_SELECTION_PARTNER swapData: ", swapData); */
    const sessionsForSlot = state.matchPoolUsers[dateTimeMS];
    /* console.log("@SET_SELECTION_PARTNER, sessions:", sessionsForSlot); */
    sessionsForSlot[0].score = oldBestScore;
    sessionsForSlot[chosenIndex].score += 100;
    sessionsForSlot.sort((a, b) => b.score - a.score);
  },
  SET_DATA_START(state, newStart) {
    state.dataStartMS = newStart;
  },
  SET_DATA_END(state, newEnd) {
    state.dataEndMS = newEnd;
  },
  /**
   * Adds keys to the calendarData
   * @param {
   *  rangeStart: {Number} the start date (inclusive)
   *  rangeEnd: {Number} the end date (inclusive )
   * } payload
   */
  ADD_DATE_TIMES(state, payload) {
    const {rangeStart, rangeEnd} = payload;
    for (let dateTimeMS=rangeStart; dateTimeMS <=rangeEnd; dateTimeMS+=SLOT_INTERVAL_MS) {
      if (!state.matchPoolUsers[dateTimeMS]) {
        Vue.set(state.matchPoolUsers, dateTimeMS, []);
      }
    }
  },
  /**
   * Replaces the current array at dateTimeMS with the array provided in the payload
   * @param {<dateTimeMS>: {Array}} payload the new payload, that reassigns all 
   */
  REASSIGN_DATETIMES(state, payload) {
    const newPool = payload;
    // const {rangeStart, rangeEnd, newPool} = payload;
    // for (let i=rangeStart; i<=rangeEnd; i+=SLOT_INTERVAL_MS) {
    //   Vue.delete(state.matchPoolUsers, i);
    // }
    state.matchPoolUsers = Object.assign(state.matchPoolUsers, newPool);
  },
  /**
   * Adds one user to matchpool
   * @param {
   *  dateTimeMS {String/Number} -- in ms datetime for slot 
   *  matchableID {String} -- user to add
   *  userSession {Object} -- user session data to add (rematchAllowed, worktype etc)
   *  position -- position where to add in matchPoolUsersForSlot Array
   * } payload 
   */
  ADD_ONE_TO_MATCH_POOL(state, payload) {
    const {dateTimeMS, matchableID, userSession, position, score} = payload;
    const elementToAdd = {
      matchableID, 
      score,
      session: userSession
    };
    if (Object.prototype.hasOwnProperty.call(state.matchPoolUsers, dateTimeMS)) {
      const newArray = state.matchPoolUsers[dateTimeMS]
      newArray.splice(position, 0, elementToAdd);
      Vue.set(state.matchPoolUsers, dateTimeMS, newArray); 
    } else {
      Vue.set(state.matchPoolUsers, dateTimeMS, [elementToAdd]);
    }
    state.matchPoolUsers[dateTimeMS].sort((a,b)=> b.score - a.score);
    const length = state.matchPoolUsers[dateTimeMS].length;
    if (length > SLOT_USER_LIMIT) {
      Vue.set(
        state.matchPoolUsers, dateTimeMS, state.matchPoolUsers[dateTimeMS].slice(0, length-1)
      );
    }
  },
  /**
   * Removes one user from matchpool
   * @param {
   *  dateTimeMS {String/Number} -- in ms datetime for slot 
   *  position -- position from where to remove in matchPoolUsersForSlot Array
   * } payload 
   */
  REMOVE_ONE_FROM_MATCH_POOL(state, payload) {
    const {dateTimeMS, position} = payload;
    const newArray = state.matchPoolUsers[dateTimeMS];
    newArray.splice(position, 1);
    Vue.set(state.matchPoolUsers, dateTimeMS, newArray);
  },
};

const actions = {
  /**
   * Hack to ensure that selected partner remains selected even if better matches appear
   * TODO: properly
   * @param {String} partnerID the ID of the selected partner
   * @param {Number} dateTimeMS the date of selected slot
   */
  setPartnerAsSelected({dispatch}, payload) {
    /* console.log("from new stuff: ", payload); */
    dispatch("setSelectionPartner", payload);
  },
  swapSelectionPartner({dispatch}, payload) {
    dispatch("setSelectionPartner", payload);
    dispatch("selections/selectSlot", payload.dateTimeMS, {root: true});
  },
  setSelectionPartner({state, commit, rootGetters}, payload) {
    const {partnerID, dateTimeMS} = payload;
    /* console.log("@setSelectionPartner swapData: ", payload); */
    const sessionsForSlot = state.matchPoolUsers[dateTimeMS];
    /* console.log("@setSelectionPartner, sessions:", sessionsForSlot); */
    /* let newBest = null; */
    let chosenIndex = 0;
    for (var i = 0; i<sessionsForSlot.length; i++) {
      let session = sessionsForSlot[i];
      if (session.matchableID == partnerID) {
        chosenIndex = i;  
        /* newBest = session; */
        break;
      }
    }
    /* console.log("@setSelectionPartner best and chose: ", chosenIndex, newBest); */
    const oldBest = state.matchPoolUsers[dateTimeMS][0];
    let oldBestScore = 0;
    if (oldBest) {
      const oldBestPrefs = rootGetters["calendarUsers/getUserPreferences"](oldBest.matchableID);
      const currentPrefs = rootGetters["calendar/getCurrentUserPublicPreferences"];
      if (oldBestPrefs && currentPrefs) {
        oldBestScore = getMatchabilityScore(currentPrefs, oldBestPrefs);
      }
    }
    commit("SET_SELECTION_PARTNER", {
      oldBestScore, 
      chosenIndex, 
      dateTimeMS
    });
  },

  /**
   * Add new calendar datetime range
   * @param {
   *  rangeStart: {Number} the start of the range to add (inclusive)
   *  rangeEnd: {Number} the end of the range to add (inclusive)
   * }
   */
  addDateTimeRange({state, commit}, payload) {
    let {rangeStart, rangeEnd} = payload;
    /* make sure datetimes are valid */
    /* console.log("@ADD_DATETIME_RANGE_IN_MATCH_POOL") */
    rangeStart = Math.floor(rangeStart/SLOT_INTERVAL_MS)*SLOT_INTERVAL_MS;
    rangeEnd = Math.floor(rangeEnd/SLOT_INTERVAL_MS+1)*SLOT_INTERVAL_MS;
    if (state.dataStartMS > rangeStart) {
      /* add earlier datetimes, do not add past datetimes as cannot match in the past */
      commit("ADD_DATE_TIMES", { 
        rangeStart: Math.min(Date.now()-SESSION_LENGTH_MS, rangeStart), 
        rangeEnd: state.dataStartMS 
      });
      commit("SET_DATA_START", rangeStart);
    }
    if (state.dataEndMS < rangeEnd) {
      /* add later datetimes */
      commit("ADD_DATE_TIMES", { rangeStart: state.dataEndMS, rangeEnd });
      commit("SET_DATA_END", rangeEnd);
    }
    
  },

  /**
   * Adds one user to matchpool, if good enough a match
   * @param {
   *  dateTimeMS: {String/Number} -- in ms datetime for slot 
   *  user: {
   *    metadata: {Object}
   *    session: {Object} // worktype etc 
   *  } 
   *  score: {Number} matchability score
   * } payload 
   * @return true if inserted, false otherwise
   */
  addOneMatchPoolUser({ state, commit }, payload) {
    const {dateTimeMS, user, score} = payload;
    if (!user || !user.metadata) 
      return false;
    if (dateTimeMS > state.dataEndMS || dateTimeMS < state.dataStartMS) {
      return false;
    }
    let userArray = state.matchPoolUsers[dateTimeMS];
    /* console.log("@addOneMatchPoolUser userArray: ", userArray ? userArray.length : userArray);
    console.log("@addOneMatchPoolUser user: ", user); */
    let position = 0;
    if (userArray) {
      /* check that does not already exist */
      for (let i=0; i<userArray.length; i++) {
        /* console.log("for i", i, userArray[i], user.metadata); */
        if (userArray[i].matchableID == user.metadata.ID) {
          return true; 
        }
      }
    }
    commit("ADD_ONE_TO_MATCH_POOL", {
      dateTimeMS,
      matchableID: user.metadata.ID,
      userSession: user.session,
      position: position ? position : 0,
      score
    });
    return true;
  },
  /**
   * Removes one user from matchpool
   * @param {
   *  dateTimeMS,
   *  ID {String} -- ID of the user who was removed from match pool at this datetime
   * } payload
   * @return true if removed, false otherwise
   */
  removeOneFromSlot({state, commit}, payload) {
    const {dateTimeMS, ID} = payload
    let userArray = state.matchPoolUsers[dateTimeMS];
    if (!userArray) 
      return false;
    let position;
    /* console.log("@matchPool/removeOneFromSlot: ", ID, userArray); */
    for (let i=0; i<userArray.length; i++) {
      if (userArray[i].matchableID === ID) {
        position = i;
        /* console.log("@removeOneMatchPoolUserFromSlot found index position: ", i); */
        break;
      }
    }
    if (position === 0 || position) {
      /* console.log("@removeOneFromSlot removed: ", position); */
      commit("REMOVE_ONE_FROM_MATCH_POOL", {
        dateTimeMS, 
        position
      });
      return true;
    }
    /* console.log("@removeOneMatchPool did not remove"); */
    return false;
  },

  /**
   * Adds the results from DB to load the calendar view. The addition is done as follows. 
   * The JSON from DB contains the userIDs as keys to reduce bandwidth. However, in the calendar the keys are datetimes. 
   * So first, we reorganize data to `reorganized` object so that we have access by datetimes. 
   * In `reorganized` the keys are datetimes in MS and values are arrays with elements
   * {
   *  matchableID -- the ID of matchable user
   *  score -- the preference matching score of the matchable user
   *  session -- the session data of the matchable user (worktype, rematch, etc)
   * }
   * Then sort this array in the order of descending score, cut this array at SLOT_USER_LIMIT and add to the Vuex state
   * @param {
   *  <matchableUserID>: {
   *    metadata: {Object} -- matchable user's metadata
   *    preferences: {Object} -- matchable user's public preferences
   *    sessions: [
   *      {
   *        d: {Number} -- dateTimeMS
   *        partner: {workType, rematch} -- partner public session data
   *      }
   *    ]
   *  }
   * } matchablePeopl
   * @param {Number} dataStart
   * @param {Number} dataEnd
   */
  addFromDB({commit, dispatch, rootGetters}, payload) {
    const {matchablePeople, dataStart, dataEnd} = payload;
    const currentUserPrefs = rootGetters["calendar/getCurrentUserPublicPreferences"];
    const newPool = {}
    generateEmptyPool(newPool, dataStart, dataEnd); 
    const matchableIDs = addPeopleToEmptyPool(currentUserPrefs, newPool, matchablePeople);
    cleanNewPool(newPool, matchablePeople);
    dispatch("calendarUsers/setUserArray", matchableIDs.filter((matchableID) => matchablePeople[matchableID].count > 0)
      .map(matchableID => {
        return {
          preferences: matchablePeople[matchableID].preferences,
          metadata: matchablePeople[matchableID].metadata
        };
      }), {root: true});
    // commit("REASSIGN_DATETIMES", {
    //   rangeStart: dataStart,
    //   rangeEnd: dataEnd,
    //   newPool
    // });
    commit("REASSIGN_DATETIMES", newPool);
    return true;
  }
};

const matchPool = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default matchPool;


/* ================ HELPERS ================ */

function generateEmptyPool(pool, dataStart, dataEnd) {
  for (let i=dataStart; i<= dataEnd; i+=SLOT_INTERVAL_MS) {
    pool[i] = [];
  }
}


/**
 * Adds all the people in matchable in matchablePeople to the pool
 * @param {Object} pool NB! gets modified in this function
 * @param {Object} matchablePeople NB! gets modified in this function
 * @return {Array} the array of IDs of matchable people
 */
function addPeopleToEmptyPool(currentUserPrefs, pool, matchablePeople) {
  const matchableIDs = Object.keys(matchablePeople);
  for (let i=0; i<matchableIDs.length; i++) {
    const matchableID = matchableIDs[i];
    const sessions = matchablePeople[matchableID].sessions;
    const matchScore = getMatchabilityScore(currentUserPrefs, matchablePeople[matchableID].preferences);
    for (let j=0; j<sessions.length; j++) {
      const dateTimeMS = Number(sessions[j].d);
      const elementToAdd = {
        matchableID, 
        score: matchScore,
        session: sessions[j].partner
      };
      if (Object.prototype.hasOwnProperty.call(pool, dateTimeMS)) {
        pool[dateTimeMS].push(elementToAdd);
      } else {
        pool[dateTimeMS] = [elementToAdd];
      }
      
    }
    matchablePeople[matchableID].count = sessions.length;
  }
  return matchableIDs;
}

/**
 * Cleans the pool -- makes sure that each datetime contains no more than SLOT_USER_LIMIT users
 * @param {Object} pool NB! gets modified in this function
 * @param {Object} matchablePeople NB! gets modified in this function
 */
function cleanNewPool(pool, matchablePeople) {
  /* Sort and splice the reorganized array */
  Object.keys(pool).forEach((dateTimeMS) => {
    if (pool[dateTimeMS].length) {
      pool[dateTimeMS].sort((a,b) => b.score - a.score);
      for (let j=pool[dateTimeMS].length; --j >= SLOT_USER_LIMIT;) {
        matchablePeople[pool[dateTimeMS][j].matchableID].count--;
      }
      pool[dateTimeMS].splice(SLOT_USER_LIMIT);
    }
  });
}

